import mapboxgl from 'mapbox-gl';
import { getZ3PConfigValue, pickColor } from '../../helper';
import SaveLatLngBoundsButton from './SaveLatLngBoundsButton';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const mapLoad = (mapperRef) => {
  const boundBox = getZ3PConfigValue('lat_lng_bounds');

  let bounds = null;
  if (boundBox?.length === 4) {
    bounds = [
      [boundBox[1], boundBox[0]],
      [boundBox[3], boundBox[2]],
    ];
  }

  return new mapboxgl.Map({
    container: mapperRef.current,
    bounds,
    // style: 'mapbox://styles/zippitymatt/ck94m63ad48b31ipiwk8yuanf', // Colored style without zip codes
    // style: 'mapbox://styles/zippitymatt/ckckq4rmf58do1jlhq3kzfzir/draft', // Monochrome with zip codes, Staging
    // style: 'mapbox://styles/zippitymatt/ckckq4rmf58do1jlhq3kzfzir', // Monochrome with zip codes, Production
    style: 'mapbox://styles/kpratt/clexgxb45000101mo2bp1rjbu',
  });
};

export const mapOnLoad = (map) => {
  map.on('load', () => {
    map.addControl(new mapboxgl.NavigationControl());
    map.addSource('us_zip_codes_simplified_2-28njg7', {
      type: 'vector',
      // url: 'mapbox://zippitymatt.68fl4pfd',
      url: 'mapbox://kpratt.23tbfp5n',
    });
  });
};

export const addSaveLatLngBoundsButton = (map) => {
  map.on('load', () => {
    map.addControl(new SaveLatLngBoundsButton(), 'top-left');
  });
};

export const addLayer = (map, vehicle, serviceAreas) => {
  map.addLayer({
    id: `us-zip-code-fill-layer-${vehicle}`,
    type: 'fill',
    source: 'us_zip_codes_simplified_2-28njg7',
    paint: {
      'fill-color': `${pickColor(vehicle)}`,
      'fill-opacity': 0.3,
    },
    'source-layer': 'us_zip_codes_simplified_2-28njg7',
    filter: ['in', ['get', 'ZIP_CODE'], ['literal', serviceAreas]],
  });
};

export default mapLoad;
